import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import { validate } from "../util/forms.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import TPL_ONE_COMMENT from "./comment.mustache";
import TPL_COMMENTSANDCO from "./commentsandco.mustache";
import Icons from "../svg/Icons.ts";
import * as modal from "../util/modal.ts";

Html.registerWidget('comments/comments-widget',{initDom})

actionMenu.register({
  commentaction(){
    var
      commentNode = Html.getDomMetaIdNode(this),
      commentId = Html.getDomMetaId(this),
      objectId = Html.getDomMetaId(commentNode.parentElement),
      comment = FwDatas.get(commentId),
      object = FwDatas.get(objectId),
      menu = [];

    if(comment.rights.canDelete){
      menu.push({svg:Icons.ic_delete,async clickFunction(){
        if(await modal.confirmDelete("wall.confirmBeforeDeletingComment")){
          ApiServer.metadelete([commentId])
          if(objectId.startsWith('event/')){
            amplify.publish('eventCommented')
          }
          object.comments = object.comments.filter(comment=>comment.metaId!==commentId)
          Html.fadeOut(commentNode,1000).then(()=>commentNode.remove())
        }
      },i18nkey:'actions.delete','color':'var(--red)'})
    }
    if(comment.rights.canUpdate){
      menu.push({svg:Icons.ic_edit,async clickFunction(){
        var text = await modal.askTextarea({
          title:"edittext.comment",
          text:comment.text
        })
        if(text!==undefined){
          var updated = await ApiServer.metaupdatetext(commentId,text)
          if(objectId.startsWith('event/')){
            amplify.publish('eventCommented')
          }
          updated.justUpdated = true
          comment.text = updated.text
          comment.textraw = updated.textraw
          comment.giphy = updated.giphy
          Html.replaceWithSingleDom(commentNode,TPL_ONE_COMMENT,updated);
        }
      },i18nkey:'actions.edit'})
    }
    return {menu}
  }
})


function initDom(node: HTMLElement){
  const form = node.querySelector("form") as HTMLFormElement;
  const commentsContainer = node.querySelector('flexcol') as HTMLElement;
  const obj = form?.querySelector("input") as HTMLInputElement;

  if(!form || !obj) return;

  if(commentsContainer && commentsContainer.children.length===0){
    commentsContainer.style.display = 'none';
  }

  const opener = node.querySelector('.fw-comments-opener');
  if(opener) {
    opener.addEventListener('click', ()=>{
      node.classList.toggle('fw-comments-open')
    });
  }

  obj.addEventListener('focus', async function(){
    const TPL = await import("../form/comment.mustache")
    obj.style.display = 'none';
    const parent = obj.parentElement as HTMLElement;
    Html.setHtmlAtEndDom(parent, TPL, {});

    parent.addEventListener('reset', function(){
      obj.style.display = '';
      const next = obj.nextElementSibling;
      if(next) next.remove();
    });
  });

  form.addEventListener('submit', async (submitEvent)=>{
    submitEvent.preventDefault();
    if(!validate(form)){
      return false;
    }

    const metaId = Html.getDomMetaId(form);
    const textarea = form.querySelector('textarea') as HTMLTextAreaElement;
    const text = textarea?.value;
    const commentResult = await ApiServer.metaaddComment(metaId, text);
    const allComments = commentResult.object.comments;
    const lastComment = allComments[allComments.length-1];

    lastComment.justUpdated = true;
    setTimeout(()=>{lastComment.justUpdated = false;}, 1000)
    //TODO add missing others types
    if(metaId.startsWith('event/')){
      amplify.publish('eventCommented')
    }
    //we update all widget comment of this id
    //if modal event is opened on the wall it is pertinent
    document.querySelectorAll<HTMLElement>("*[data-widget='comments/comments-widget']").forEach(widget=>{
      if(Html.getDomMetaId(widget)===metaId){
        Html.replaceWithSingleDom(widget,TPL_COMMENTSANDCO,commentResult.object)
      }
    })
    document.querySelectorAll('[data-fw-meta-id="'+metaId+'"]').forEach(dom=>{
      dom.setAttribute('data-fw-meta-id',commentResult.object.metaId)
    })

  });
}
